// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"20639da7","182":"06878261","448":"ef69e7cb","497":"06878261","743":"06878261","768":"6bc7d87e","873":"06878261"}[chunkId] + ".chunk.css";
};